<h3 mat-dialog-title>{{ data.type === 'folder' ? 'Klasör' : 'Evrak' }} silme işlemi</h3>
<div mat-dialog-content>
    <p>{{ getConfirmationMessage() }}</p>
</div>
<div mat-dialog-actions align="end">
    <button mat-button color="warn" class="warn-button" (click)="deleteFile(data)">Evet, Sil</button>
    <button mat-button [mat-dialog-close]="false" cdkFocusInitial>İptal</button>
</div>